import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MakerAdPageApply, MakerSubmitApplication } from "@faire/retailer-visitor-shared/events";
import { isE2E } from "@faire/retailer-visitor-shared/lib/isE2E";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { getSettingMarketingSMSEligibleCountries } from "@faire/retailer-visitor-shared/settings/getSettingMarketingSMSEligibleCountries";
import { BrandStore } from "@faire/retailer-visitor-shared/stores/domain/BrandStore";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { BRAND_SIGN_UP_VALIDATION_RULES, MAKER_SIGN_UP_BASED_IN_STORAGE_KEY, validateUrlWithErrors } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/consts";
import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "@faire/web--source/common/consts/ISO_TO_COUNTRY_NAME";
import { ErrorMessages, getErrorMessage } from "@faire/web--source/common/getErrorMessage";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { throttleIfPossible } from "@faire/web--source/common/globals/throttleIfPossible";
import { logAssert, logError } from "@faire/web--source/common/logging";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { LocalStorage } from "@faire/web--source/common/Storage";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { Viewport } from "@faire/web--source/common/Viewport";
import { removeLocaleFromUrl } from "@faire/web--source/ui/routing/util";
import submitBrandLead from "@faire/web-api--source/api/brand-lead/post";
import referralInviteClicked from "@faire/web-api--source/api/brand-lead/referral-invite-clicked/post";
import validateEmail from "@faire/web-api--source/api/brand-lead/validate-email/post";
import validateTemporaryPosLinkKey from "@faire/web-api--source/api/brand-lead/validate-temporary-pos-link-key/temporaryPosLinkKey/get";
import getInvitingRetailers, { QueryParameters as GetInvitingRetailersParameters } from "@faire/web-api--source/api/retailer-to-maker/inviting-retailers/get";
import getPublicRetailer from "@faire/web-api--source/api/retailer/public/retailerToken/get";
import { trackBrandLeadsInboundBrandApplyRedirect } from "@faire/web-api--source/events/brandLeads/actionUnknown/inboundBrandApplyRedirect";
import { trackBrandLeadsBrandsFormBusinessNameClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormBusinessName";
import { trackBrandLeadsBrandsFormBusinessWebsiteClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormBusinessWebsite";
import { trackBrandLeadsBrandsFormCountryClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormCountry";
import { trackBrandLeadsBrandsFormDesktopNavigationNextClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormDesktopNavigationNext";
import { trackBrandLeadsBrandsFormDesktopNavigationReturnClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormDesktopNavigationReturn";
import { trackBrandLeadsBrandsFormEmailAddressClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormEmailAddress";
import { trackBrandLeadsBrandsFormHearAboutFaireClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormHearAboutFaire";
import { trackBrandLeadsBrandsFormMobileNavigationFirstBackClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormMobileNavigationFirstBack";
import { trackBrandLeadsBrandsFormMobileNavigationSecondNextClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormMobileNavigationSecondNext";
import { trackBrandLeadsBrandsFormNumberOfStoresClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormNumberOfStores";
import { trackBrandLeadsBrandsFormProductTypeClick } from "@faire/web-api--source/events/brandLeads/click/brandsFormProductType";
import { trackBrandLeadsBrandSignUpFromFaireMarketClick } from "@faire/web-api--source/events/brandLeads/click/brandSignUpFromFaireMarket";
import { trackBrandLeadsInboundBrandReferralLinkView } from "@faire/web-api--source/events/brandLeads/view/inboundBrandReferralLink";
import { IBrandLead } from "@faire/web-api--source/indigofair/data/IBrandLead";
import { IBrandLeadReferralInviteClickedRequest } from "@faire/web-api--source/indigofair/data/IBrandLeadReferralInviteClickedRequest";
import { ICreateBrandLeadRequest } from "@faire/web-api--source/indigofair/data/ICreateBrandLeadRequest";
import { route as brandAdApplicationRoute } from "@faire/web-api--source/routes/apply/ad";
import { route as brandToBrandApplyRoute } from "@faire/web-api--source/routes/apply/brandTokenOrAlias";
import { route as brandMarketsApplicationRoute } from "@faire/web-api--source/routes/apply/markets";
import { route as retailerToBrandApplyRoute } from "@faire/web-api--source/routes/apply/r/retailerTokenSuffix";
import { route as brandOnboardingRoute } from "@faire/web-api--source/routes/brand-portal/brand-onboarding";
import { route as brandsHomeRoute } from "@faire/web-api--source/routes/brands";
import { WebApiError } from "@faire/web-api--source/WebApiError";
import isUndefined from "lodash/isUndefined";
import keys from "lodash/keys";
import mapValues from "lodash/mapValues";
import once from "lodash/once";
import pickBy from "lodash/pickBy";
import { action, computed, observable, reaction } from "mobx";
import { matchPath } from "react-router-dom";
import validate from "validate.js";
import { INBOUND_BRAND_CATEGORY_OPTIONS } from "@faire/retailer/features/MakerApplication/MakerApplicationCategories";
import { getBrandSignupAutoAcceptedCountriesOptions, getBrandSignupAutoAcceptedThreeLetterCodes } from "@faire/retailer/features/MakerApplication/MakerApplicationCountries";
import { MakerApplicationDataFormStorage } from "@faire/retailer/views/apply/MakerApplication/MakerSignUp/MakerApplicationDataFormStorage";
import { MAKER_APPLICATION_DEFAULT_FORM_DATA } from "./MakerSignUp/useMakerApplicationDataForm";
export var MakerApplicationStages;
(function(MakerApplicationStages) {
    MakerApplicationStages[MakerApplicationStages["LANDING"] = 0] = "LANDING";
    MakerApplicationStages[MakerApplicationStages["FORM"] = 1] = "FORM";
    MakerApplicationStages[MakerApplicationStages["ADDITIONAL_QUESTIONS"] = 2] = "ADDITIONAL_QUESTIONS";
    MakerApplicationStages[MakerApplicationStages["WAITLIST"] = 3] = "WAITLIST";
    MakerApplicationStages[MakerApplicationStages["UNSUPPORTED_AREA"] = 4] = "UNSUPPORTED_AREA";
})(MakerApplicationStages || (MakerApplicationStages = {}));
export var MakerSignUpState = /*#__PURE__*/ function() {
    "use strict";
    function MakerSignUpState(strictLocalize, history) {
        var _this = this;
        _class_call_check(this, MakerSignUpState);
        var _this1 = this;
        this.strictLocalize = strictLocalize;
        this.history = history;
        this.email = "";
        this.brandLeadToken = null;
        this.temporaryPosLinkKey = undefined;
        this.companyName = "";
        this.referringRetailers = [];
        this.url = "";
        this.country = this.getCountryDefaultValue();
        this.brandLeadCreationFailure = false;
        this.acceptedTerms = false;
        // Object that contains descriptions of all the validation errors in the above form.
        // If a key is present, it means the field with the same name has an issue and the value
        // for that key will be a description of the problem. If there are no keys in this object
        // there are no known validation errors.
        this.formErrors = {};
        this.apiErrors = {};
        this.urlValidationInProgress = false;
        this.applicationStage = this.isReferral || this.isAd ? MakerApplicationStages.LANDING : MakerApplicationStages.FORM;
        this.countryDropdownOption = getBrandSignupAutoAcceptedCountriesOptions(this.strictLocalize);
        this.loading = false;
        this.makerApplicationDataFormStorage = new MakerApplicationDataFormStorage();
        this.initializeCountryDropdownOption = function() {
            var retailerIso = _this.country.isoCode;
            if (retailerIso !== "Other" && retailerIso !== "") {
                var optionArr = [];
                _this.countryDropdownOption.forEach(function(option) {
                    if (option.value === retailerIso) {
                        optionArr = [
                            option
                        ].concat(_to_consumable_array(optionArr));
                    } else {
                        optionArr.push(option);
                    }
                });
                _this.countryDropdownOption = optionArr;
            }
        };
        this.initializeFormData = function() {
            var formData = _this.makerApplicationDataFormStorage.formData;
            if (formData) {
                var _formData_url;
                _this.url = (_formData_url = formData.url) !== null && _formData_url !== void 0 ? _formData_url : "";
                var _formData_email;
                _this.email = (_formData_email = formData.email) !== null && _formData_email !== void 0 ? _formData_email : "";
                var _formData_companyName;
                _this.companyName = (_formData_companyName = formData.companyName) !== null && _formData_companyName !== void 0 ? _formData_companyName : "";
                _this.categoryOption = formData.categoryOption;
                _this.secondaryCategoryOptions = new Set();
                var _formData_country;
                _this.country = (_formData_country = formData.country) !== null && _formData_country !== void 0 ? _formData_country : {
                    isoCode: "",
                    displayName: ""
                };
                _this.numProducts = formData.numProducts;
                _this.stockists = formData.stockists;
            } else {
                _this.makerApplicationDataFormStorage.initialize(MAKER_APPLICATION_DEFAULT_FORM_DATA);
            }
        };
        this.storeFormData = throttleIfPossible(function(field) {
            var _this_makerApplicationDataFormStorage_formData;
            var formData = (_this_makerApplicationDataFormStorage_formData = _this.makerApplicationDataFormStorage.formData) !== null && _this_makerApplicationDataFormStorage_formData !== void 0 ? _this_makerApplicationDataFormStorage_formData : MAKER_APPLICATION_DEFAULT_FORM_DATA;
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            formData[field] = _this[field];
            _this.makerApplicationDataFormStorage.setData(formData);
        }, 1000);
        this.initialize = /*#__PURE__*/ _async_to_generator(function() {
            var _this_referringRetailer, _this_referringBrand, referringRetailer, referringBrand, _this, _this_referringRetailer1, _this_referringBrand1, _this_referringRetailer_token, _this_referringBrand_token;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this1.isReferral || !_this1.tokenFromPath) {
                            return [
                                2
                            ];
                        }
                        _this1.loading = true;
                        if (!_this1.isReferral) return [
                            3,
                            2
                        ];
                        if (_this1.email) {
                            _this1.trackInviteClicked(_this1.email);
                        }
                        return [
                            4,
                            getPublicRetailer(_this1.retailerTokenFromPath).then(function(response) {
                                return response.retailer;
                            }).catch(function(_) {
                                return undefined;
                            })
                        ];
                    case 1:
                        referringRetailer = _state.sent();
                        if (referringRetailer) {
                            _this1.assign({
                                referringRetailer: referringRetailer
                            });
                        }
                        _state.label = 2;
                    case 2:
                        if (!(_this1.isM2M && !_this1.referringBrand)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            BrandStore.get().getBrand(_this1.tokenFromPath).catch(function(_) {
                                return undefined;
                            })
                        ];
                    case 3:
                        referringBrand = _state.sent();
                        if (referringBrand) {
                            _this1.assign({
                                referringBrand: referringBrand
                            });
                        }
                        _state.label = 4;
                    case 4:
                        if (!_this1.brandLeadToken) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            getInvitingRetailers(GetInvitingRetailersParameters.build({
                                brandLeadToken: _this1.brandLeadToken
                            })).catch(function(_) {
                                return undefined;
                            })
                        ];
                    case 5:
                        _this1.referringRetailers = ((_this = _state.sent()) === null || _this === void 0 ? void 0 : _this.retailers) || [];
                        _state.label = 6;
                    case 6:
                        _this1.loading = false;
                        if (((_this_referringRetailer = _this1.referringRetailer) === null || _this_referringRetailer === void 0 ? void 0 : _this_referringRetailer.token) || ((_this_referringBrand = _this1.referringBrand) === null || _this_referringBrand === void 0 ? void 0 : _this_referringBrand.token)) {
                            ;
                            ;
                            trackBrandLeadsInboundBrandReferralLinkView((_this_referringRetailer_token = (_this_referringRetailer1 = _this1.referringRetailer) === null || _this_referringRetailer1 === void 0 ? void 0 : _this_referringRetailer1.token) !== null && _this_referringRetailer_token !== void 0 ? _this_referringRetailer_token : "", (_this_referringBrand_token = (_this_referringBrand1 = _this1.referringBrand) === null || _this_referringBrand1 === void 0 ? void 0 : _this_referringBrand1.token) !== null && _this_referringBrand_token !== void 0 ? _this_referringBrand_token : "");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        this.setUrlValidationResults = function(errors) {
            _this.urlValidationInProgress = false;
            if (errors) {
                _this.formErrors.url = errors;
            }
        };
        this.validateUrl = function() {
            delete _this.formErrors.url;
            _this.urlValidationInProgress = true;
            _this.urlValidationPromise = validateUrlWithErrors(_this.url, _this.strictLocalize);
            _this.urlValidationPromise.then(_this.setUrlValidationResults);
        };
        this.validateEmailAddress = /*#__PURE__*/ _async_to_generator(function() {
            var validationResponse;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        delete _this1.formErrors.email;
                        return [
                            4,
                            validateEmail({
                                email_address: _this1.email
                            })
                        ];
                    case 1:
                        validationResponse = _state.sent();
                        if (!validationResponse.is_valid) {
                            _this1.formErrors.email = _this1.strictLocalize({
                                id: "oLpv29",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Please enter a valid email address"
                                    }
                                ]
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        this.validateTemporaryPosLinkKey = /*#__PURE__*/ _async_to_generator(function() {
            var response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this1.temporaryPosLinkKey) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validateTemporaryPosLinkKey(_this1.temporaryPosLinkKey)
                        ];
                    case 1:
                        response = _state.sent();
                        switch(response.temporary_pos_link_key_validation_result){
                            case "ALREADY_LINKED":
                                _this1.setApiErrors(_define_property({}, "error", _this1.strictLocalize({
                                    id: "IsT8dR",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Shopify account already linked."
                                        }
                                    ]
                                })));
                                return [
                                    2,
                                    false
                                ];
                            case "NO_POS_LINK_FOUND":
                            case "EMPTY_REQUEST":
                            case "TEMPORARY_POS_LINK_KEY_VALIDATION_RESULT_UNKNOWN":
                                _this1.setApiErrors(_define_property({}, "error", _this1.strictLocalize({
                                    id: "EElC25",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Your link may have expired, please try again from Shopify."
                                        }
                                    ]
                                })));
                                return [
                                    2,
                                    false
                                ];
                            default:
                                return [
                                    2,
                                    true
                                ];
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        this.setApiErrors = function(apiErrors) {
            _this.apiErrors = apiErrors;
        };
        this.toggleAcceptedTerms = function() {
            _this.acceptedTerms = !_this.acceptedTerms;
        };
        this.setCountry = function(country) {
            _this.country = country;
            _this.storeFormData("country");
            delete _this.formErrors["country.isoCode"];
        };
        this.setBrandLeadToken = function(brandLeadToken) {
            _this.brandLeadToken = brandLeadToken;
        };
        this.setTemporaryPosLinkKey = function(temporaryPosLinkKey) {
            _this.temporaryPosLinkKey = temporaryPosLinkKey;
        };
        this.setApplicationStage = function(applicationStage) {
            _this.applicationStage = applicationStage;
        };
        this.assign = function(fields) {
            Object.assign(_this, fields);
        };
        this.setEmailAddress = function(email) {
            _this.email = email;
        };
        this.handleFormSubmit = function(res) {
            var _this_brandLeadResponse;
            var brandLead = res.brand_lead;
            logAssert(!!brandLead, "brandLead should always be defined");
            logAssert(!!brandLead.token, "brandLead.token should always be defined");
            _this.brandLeadToken = brandLead.token;
            if (_this.isAd) {
                MakerAdPageApply.publish(brandLead);
            } else {
                MakerSubmitApplication.publish(brandLead);
            }
            if (_this.isFromFaireMarkets) {
                trackBrandLeadsBrandSignUpFromFaireMarketClick();
            }
            LocalStorage.get().removeItem(MAKER_SIGN_UP_BASED_IN_STORAGE_KEY);
            _this.brandLeadResponse = res;
            // If onboarding_params is present, then brand's application was accepted
            if ((_this_brandLeadResponse = _this.brandLeadResponse) === null || _this_brandLeadResponse === void 0 ? void 0 : _this_brandLeadResponse.onboarding_params) {
                // redirect to brand onboarding flow
                _this.makerApplicationDataFormStorage.clearData();
                trackBrandLeadsInboundBrandApplyRedirect("onboarding");
                _this.history.push(_this.onboardingUrl);
            } else {
                var _this_brandLeadResponse1;
                if (((_this_brandLeadResponse1 = _this.brandLeadResponse) === null || _this_brandLeadResponse1 === void 0 ? void 0 : _this_brandLeadResponse1.is_supported_country) === false) {
                    trackBrandLeadsInboundBrandApplyRedirect("unsupported-area");
                    _this.assign({
                        applicationStage: MakerApplicationStages.UNSUPPORTED_AREA
                    });
                } else {
                    trackBrandLeadsInboundBrandApplyRedirect("waitlist");
                    _this.assign({
                        applicationStage: MakerApplicationStages.WAITLIST
                    });
                }
            }
        };
        this.trackInviteClicked = once(function(email) {
            if (_this.isM2M) {
                if (!_this.brandTokenOrAlias) {
                    return;
                }
                referralInviteClicked(IBrandLeadReferralInviteClickedRequest.build({
                    brand_token_alias: _this.brandTokenOrAlias,
                    brand_email_address: email
                }));
                return;
            }
            if (!_this.retailerTokenFromPath) {
                return;
            }
            referralInviteClicked(IBrandLeadReferralInviteClickedRequest.build({
                retailer_token: _this.retailerTokenFromPath,
                brand_email_address: email
            }));
        });
        this.onBrandLeadCreationFailure = function() {
            // Flip flag so the creation failure is known on the loading screen
            _this.brandLeadCreationFailure = true;
        };
        this.validate = /*#__PURE__*/ _async_to_generator(function() {
            var validationRules, validationErrors;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.validateEmailAddress()
                        ];
                    case 1:
                        _state.sent();
                        if (typeof _this1.urlValidationPromise === "undefined") {
                            // We've never validated this field (it's probably empty). Validate it now.
                            _this1.validateUrl();
                        }
                        // Now wait for any URL validation operations to complete
                        return [
                            4,
                            _this1.urlValidationPromise
                        ];
                    case 2:
                        _state.sent();
                        // Validate the rest of the content
                        validationRules = BRAND_SIGN_UP_VALIDATION_RULES(_this1.strictLocalize);
                        validationErrors = validate.validate(_this1, validationRules);
                        if (typeof validationErrors === "undefined") {
                            validationErrors = {};
                        } else {
                            // validate.js gives us back an array of errors for each value, just take the first one
                            // for each.
                            validationErrors = mapValues(validationErrors, function(value) {
                                return value[0];
                            });
                        }
                        _this1.formErrors = pickBy(_object_spread_props(_object_spread({}, validationErrors), {
                            url: _this1.formErrors.url,
                            email: _this1.formErrors.email,
                            companyName: validationErrors.companyName
                        }));
                        return [
                            2,
                            keys(_this1.formErrors).length === 0
                        ];
                }
            });
        });
        this.errorFor = function(property) {
            return _this.formErrors[property] || _this.apiErrors[property];
        };
        this.onChange = function(event) {
            _this.setFormField(event.target.name, event.target.value);
        };
        this.onBackClick = function() {
            trackBrandLeadsBrandsFormMobileNavigationFirstBackClick();
            _this.history.push(brandsHomeRoute);
        };
        this.onUrlBlur = function(event) {
            _this.websiteUrlEvent();
            _this.setFormField("url", event.target.value);
        };
        this.getFieldName = function(apiFieldName) {
            // this mapping allows us to translate api errors into field names
            // that can be highlighted in red
            var API_FIELD_NAME_MAP = {
                phone_number: "phone",
                email_address: "email"
            };
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            return API_FIELD_NAME_MAP[apiFieldName] || apiFieldName;
        };
        this.onSubmit = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(event) {
                var isTemporaryPosKeyValid, alreadyHadFormError, isValid, companyName, url, email, categoryOption, secondaryCategoryOptions, country, stockists, numProducts, handleFormSubmit, referringBrand, referringRetailer, temporaryPosLinkKey, categoryValue, payloadBase, payload;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            event.stopPropagation();
                            event.preventDefault();
                            return [
                                4,
                                _this1.validateTemporaryPosLinkKey()
                            ];
                        case 1:
                            isTemporaryPosKeyValid = _state.sent();
                            if (!isTemporaryPosKeyValid) {
                                return [
                                    2
                                ];
                            }
                            alreadyHadFormError = _this1.hasFormError;
                            _this1.setApiErrors({});
                            return [
                                4,
                                _this1.validate()
                            ];
                        case 2:
                            isValid = _state.sent();
                            if (!isValid) {
                                if (alreadyHadFormError) {
                                    // Shake the button.
                                    throw new Error();
                                } else {
                                    return [
                                        2
                                    ];
                                }
                            }
                            companyName = _this1.companyName, url = _this1.url, email = _this1.email, categoryOption = _this1.categoryOption, secondaryCategoryOptions = _this1.secondaryCategoryOptions, country = _this1.country, stockists = _this1.stockists, numProducts = _this1.numProducts, handleFormSubmit = _this1.handleFormSubmit, referringBrand = _this1.referringBrand, referringRetailer = _this1.referringRetailer, temporaryPosLinkKey = _this1.temporaryPosLinkKey;
                            categoryValue = categoryOption === null || categoryOption === void 0 ? void 0 : categoryOption.value;
                            payloadBase = {
                                company_name: companyName,
                                url: url,
                                email_address: email,
                                number_of_stockists: stockists,
                                number_of_products: numProducts,
                                referring_brand_token_alias: referringBrand === null || referringBrand === void 0 ? void 0 : referringBrand.token_alias,
                                referring_retailer_token: referringRetailer === null || referringRetailer === void 0 ? void 0 : referringRetailer.token,
                                source: _this1.source,
                                primary_category: categoryValue,
                                country: country.isoCode,
                                secondary_categories: _this1.shouldCollectSecondaryProductCategory ? _to_consumable_array(secondaryCategoryOptions || []) : []
                            };
                            payload = IBrandLead.build(payloadBase);
                            _this1.submitEvent();
                            return [
                                4,
                                submitBrandLead(ICreateBrandLeadRequest.build({
                                    brand_lead: payload,
                                    term_of_service_accepted: true,
                                    temporary_pos_link_key: temporaryPosLinkKey
                                })).then(function(response) {
                                    if (response.brand_lead) {
                                        handleFormSubmit(response);
                                    } else {
                                        _this1.onBrandLeadCreationFailure();
                                        throw new Error(_this1.strictLocalize({
                                            id: "hhPOBK",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "Uploading Lead Failed"
                                                }
                                            ]
                                        }));
                                    }
                                }).catch(function(submitError) {
                                    _this1.onBrandLeadCreationFailure();
                                    logError(submitError);
                                    if (submitError instanceof WebApiError) {
                                        var fieldName = submitError.responseData.field ? _this1.getFieldName(submitError.responseData.field) : "error";
                                        _this1.setApiErrors(_define_property({}, fieldName, submitError.responseData.localized_message || submitError.responseData.message || ""));
                                    } else {
                                        _this1.setApiErrors({
                                            error: getErrorMessage(_this1.strictLocalize, ErrorMessages.PLEASE_TRY_AGAIN_OR_CONTACT_SUPPORT)
                                        });
                                    }
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
        // existing events that are changed to PETE
        this.brandNameEvent = once(function() {
            return trackBrandLeadsBrandsFormBusinessNameClick();
        });
        this.websiteUrlEvent = once(function() {
            return trackBrandLeadsBrandsFormBusinessWebsiteClick();
        });
        this.emailEvent = once(function() {
            return trackBrandLeadsBrandsFormEmailAddressClick();
        });
        this.categoryEvent = once(function() {
            return trackBrandLeadsBrandsFormProductTypeClick();
        });
        this.numberStoresEvent = once(function() {
            return trackBrandLeadsBrandsFormNumberOfStoresClick();
        });
        this.countryEvent = once(function() {
            return trackBrandLeadsBrandsFormCountryClick();
        });
        this.sourceEvent = once(function() {
            return trackBrandLeadsBrandsFormHearAboutFaireClick();
        });
        // new PETE events
        this.submitEvent = once(function() {
            if (Viewport.getDefault().isMobile) {
                trackBrandLeadsBrandsFormMobileNavigationSecondNextClick();
            } else {
                trackBrandLeadsBrandsFormDesktopNavigationNextClick();
            }
        });
        this.returnEvent = once(function() {
            return trackBrandLeadsBrandsFormDesktopNavigationReturnClick();
        });
        // old
        this.numberProductsEvent = once(function() {
            return trackEvent("maker-application/number-products".concat(_this.endOfEvent));
        });
        makeObservable(this);
        this.secondaryCategoryOptions = new Set();
        reaction(function() {
            return _this.url;
        }, function() {
            return _this.validateUrl();
        });
    }
    var _proto = MakerSignUpState.prototype;
    // We're hoisting this method to declare country above it.
    // eslint-disable-next-line @faire/prefer-arrow-methods
    _proto.getCountryDefaultValue = function getCountryDefaultValue() {
        var retailerIso = RetailerStore.get().retailerCountry || "";
        if (getBrandSignupAutoAcceptedThreeLetterCodes().includes(retailerIso)) {
            return {
                isoCode: retailerIso,
                // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                displayName: ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(this.strictLocalize)[retailerIso]
            };
        } else {
            return {
                isoCode: retailerIso,
                displayName: this.strictLocalize({
                    id: "m6ya0Z",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Other"
                        }
                    ]
                })
            };
        }
    };
    // Type parameter V has a circular constraint
    // eslint-disable-next-line @faire/prefer-arrow-methods
    _proto.setFormField = function setFormField(fieldName, value) {
        // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
        if (this[fieldName] !== value) {
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            this[fieldName] = value;
            this.storeFormData(fieldName);
            delete this.formErrors[fieldName]; // Reset error state if it exists
        }
    };
    _create_class(MakerSignUpState, [
        {
            key: "displaySource",
            get: function get() {
                return this._source;
            }
        },
        {
            key: "source",
            get: function get() {
                if (this._source) {
                    return this._source;
                }
                if (this.isAd) {
                    return IBrandLead.Source.DIGITAL_ADS;
                }
                if (this.isR2M) {
                    return IBrandLead.Source.RETAILER_REFERRAL;
                }
                if (this.isM2M) {
                    return IBrandLead.Source.BRAND_REFERRAL;
                }
                return IBrandLead.Source.ORGANIC;
            }
        },
        {
            key: "referrerInformation",
            get: function get() {
                if (this.isR2M && this.referringRetailer) {
                    return {
                        name: this.referringRetailer.name,
                        image: this.referringRetailer.profile_image
                    };
                } else if (this.isM2M && this.referringBrand) {
                    return {
                        name: this.referringBrand.name,
                        image: this.referringBrand.squared_image
                    };
                }
                return null;
            }
        },
        {
            key: "tokenFromPath",
            get: function get() {
                return getLocationOrThrow().pathname.split("/").pop();
            }
        },
        {
            key: "retailerTokenFromPath",
            get: function get() {
                if (!this.tokenFromPath) {
                    return null;
                }
                return "r_".concat(this.tokenFromPath.toLowerCase());
            }
        },
        {
            key: "brandTokenOrAlias",
            get: function get() {
                if (!this.tokenFromPath) {
                    return undefined;
                }
                return this.tokenFromPath;
            }
        },
        {
            key: "countryLabel",
            get: function get() {
                return this.country.isoCode;
            }
        },
        {
            key: "otherReferringRetailerCount",
            get: function get() {
                var _this = this;
                if (!this.isR2M || !this.retailerTokenFromPath) {
                    return 0;
                }
                return this.referringRetailers.filter(function(retailer) {
                    return retailer.retailer_token !== _this.retailerTokenFromPath;
                }).length;
            }
        },
        {
            key: "isUrlValid",
            get: function get() {
                return this.url && !this.urlValidationInProgress && (!this.formErrors || !this.formErrors.url);
            }
        },
        {
            key: "shouldShowSMSOptIn",
            get: function get() {
                var sessionCountry = getSessionCountry();
                return isE2E() || getSettingMarketingSMSEligibleCountries().some(function(eligibleCountry) {
                    return eligibleCountry === sessionCountry;
                });
            }
        },
        {
            key: "isAd",
            get: function get() {
                return matchPath(removeLocaleFromUrl(getLocationOrThrow().pathname), {
                    path: removeLocaleFromUrl(brandAdApplicationRoute),
                    exact: true
                });
            }
        },
        {
            key: "isR2M",
            get: function get() {
                return matchPath(removeLocaleFromUrl(getLocationOrThrow().pathname), {
                    path: removeLocaleFromUrl(retailerToBrandApplyRoute),
                    exact: true
                });
            }
        },
        {
            key: "isM2M",
            get: function get() {
                // The Ad url and M2M urls clash, so we must check explicitly for ad here
                return !this.isAd && matchPath(removeLocaleFromUrl(getLocationOrThrow().pathname), {
                    path: removeLocaleFromUrl(brandToBrandApplyRoute),
                    exact: true
                });
            }
        },
        {
            key: "isFromFaireMarkets",
            get: function get() {
                return matchPath(removeLocaleFromUrl(getLocationOrThrow().pathname), {
                    path: removeLocaleFromUrl(brandMarketsApplicationRoute),
                    exact: true
                });
            }
        },
        {
            key: "isReferral",
            get: function get() {
                return this.isR2M || this.isM2M;
            }
        },
        {
            key: "selectedProductCategory",
            get: function get() {
                var _this = this;
                return INBOUND_BRAND_CATEGORY_OPTIONS(this.strictLocalize).find(function(opt) {
                    var _this_categoryOption;
                    return opt.value === ((_this_categoryOption = _this.categoryOption) === null || _this_categoryOption === void 0 ? void 0 : _this_categoryOption.value);
                });
            }
        },
        {
            key: "shouldCollectSecondaryProductCategory",
            get: function get() {
                var _this_categoryOption;
                var stockistsLessThan25 = !isUndefined(this.stockists) && this.stockists <= 25;
                var currentSelectedCategoryOption = this.selectedProductCategory;
                return stockistsLessThan25 && ((_this_categoryOption = this.categoryOption) === null || _this_categoryOption === void 0 ? void 0 : _this_categoryOption.value) && currentSelectedCategoryOption.subCategories.length > 0;
            }
        },
        {
            key: "onboardingUrl",
            get: function get() {
                var _this_brandLeadResponse;
                if ((_this_brandLeadResponse = this.brandLeadResponse) === null || _this_brandLeadResponse === void 0 ? void 0 : _this_brandLeadResponse.onboarding_params) {
                    return "".concat(brandOnboardingRoute, "?").concat(this.brandLeadResponse.onboarding_params);
                }
                return "";
            }
        },
        {
            key: "calendlyUrl",
            get: function get() {
                var _this_brandLeadResponse_account_owner, _this_brandLeadResponse;
                return (_this_brandLeadResponse = this.brandLeadResponse) === null || _this_brandLeadResponse === void 0 ? void 0 : (_this_brandLeadResponse_account_owner = _this_brandLeadResponse.account_owner) === null || _this_brandLeadResponse_account_owner === void 0 ? void 0 : _this_brandLeadResponse_account_owner.calendar_url;
            }
        },
        {
            key: "onClickTellUsMoreFunction",
            get: function get() {
                var _this = this;
                var _this_brandLeadResponse;
                if (!((_this_brandLeadResponse = this.brandLeadResponse) === null || _this_brandLeadResponse === void 0 ? void 0 : _this_brandLeadResponse.can_provide_more_info)) {
                    return undefined;
                } else {
                    return function() {
                        return _this.assign({
                            applicationStage: MakerApplicationStages.ADDITIONAL_QUESTIONS
                        });
                    };
                }
            }
        },
        {
            key: "hasFormError",
            get: function get() {
                return keys(this.formErrors).length > 0;
            }
        },
        {
            key: "endOfEvent",
            get: function get() {
                if (this.isAd) {
                    return "/ad";
                } else if (this.isR2M) {
                    return "/r2m";
                } else if (this.isM2M) {
                    return "/m2m";
                }
                return "";
            }
        }
    ]);
    return MakerSignUpState;
}();
__decorate([
    observable
], MakerSignUpState.prototype, "email", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "brandLeadToken", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "temporaryPosLinkKey", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "companyName", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "referringRetailers", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "url", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "categoryOption", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "secondaryCategoryOptions", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "country", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "stockists", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "numProducts", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "brandLeadResponse", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "brandLeadCreationFailure", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "acceptedTerms", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "_source", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "formErrors", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "apiErrors", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "urlValidationInProgress", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "applicationStage", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "referringBrand", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "referringRetailer", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "countryDropdownOption", void 0);
__decorate([
    observable
], MakerSignUpState.prototype, "loading", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "initializeCountryDropdownOption", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "initializeFormData", void 0);
__decorate([
    computed
], MakerSignUpState.prototype, "referrerInformation", null);
__decorate([
    computed
], MakerSignUpState.prototype, "countryLabel", null);
__decorate([
    computed
], MakerSignUpState.prototype, "otherReferringRetailerCount", null);
__decorate([
    action
], MakerSignUpState.prototype, "setUrlValidationResults", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "validateUrl", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "validateEmailAddress", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "validateTemporaryPosLinkKey", void 0);
__decorate([
    computed
], MakerSignUpState.prototype, "isUrlValid", null);
__decorate([
    action
], MakerSignUpState.prototype, "setApiErrors", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "toggleAcceptedTerms", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "setFormField", null);
__decorate([
    action
], MakerSignUpState.prototype, "setCountry", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "setBrandLeadToken", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "setTemporaryPosLinkKey", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "setApplicationStage", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "assign", void 0);
__decorate([
    action
], MakerSignUpState.prototype, "setEmailAddress", void 0);
__decorate([
    computed
], MakerSignUpState.prototype, "shouldShowSMSOptIn", null);
__decorate([
    action
], MakerSignUpState.prototype, "handleFormSubmit", void 0);
__decorate([
    computed
], MakerSignUpState.prototype, "onClickTellUsMoreFunction", null);
__decorate([
    action
], MakerSignUpState.prototype, "validate", void 0);
__decorate([
    computed
], MakerSignUpState.prototype, "hasFormError", null);
__decorate([
    action
], MakerSignUpState.prototype, "onBackClick", void 0);
__decorate([
    computed
], MakerSignUpState.prototype, "endOfEvent", null);
__decorate([
    action
], MakerSignUpState.prototype, "onSubmit", void 0);
